import { getEvents } from '3-foundation/Events/repository';
import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

export const mapEventCatalogPageProperties = async (
	properties: Umbraco.BasePage,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.EventCatalogPageProperties> => {
	try {
		const { items, tags, totalItems } = await getEvents({
			filters: {
				parentId: pageId,
			},
			siteId,
			locale,
		});
		if (!items) throw new Error('No results from getEvents');

		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			events: items,
			filterTags: tags,
			totalEvents: totalItems,
		};
	} catch (e) {
		logger.error('Could not map EventCatalogPage Properties. \nCause: ' + e, { cause: e });
		throw new Error('Could not map EventCatalogPage Properties. \nCause: ' + e, { cause: e });
	}
};
